import {Component} from "react";
import SectionTitle from "../SectionTitle";
import "./TSRServicesSstyles.css"
import DisplayScreens from "../DisplayScreens";
import TsrServicesList from "./TsrServicesList";
import FancyNavigation from "../ScrollSpyPagination/PaginationNavigation";
import Fade from 'react-reveal/Fade';

class TSRServices extends Component {
    constructor() {
        super();
        this.state = {
            isMobile: window.innerWidth <= 768,
            images: ['./tsr/CN_TSR_1.svg', './tsr/CN_TSR_1.png', './tsr/CN_TSR_2.svg', './tsr/CN_TSR_2.png', './tsr/CN_TSR_3.svg', './tsr/CN_TSR_3.png'],
            isRetina: window.devicePixelRatio >= 2
        }
        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
    }

    handleResize() {
        if (window.innerWidth <= 768) {
            this.setState({isMobile: true});
        } else {
            this.setState({isMobile: false});
        }
    }

    render() {
        let text = ["Пользуйтесь Удобными Сервисами", <br/>, "для обеспечения ТЕХНИЧЕСКИМИ СРЕДСТВАМИ РЕАБИЛИТАЦИИ"];
        let titleWidth = 70;
        if (this.state.isMobile) {
            titleWidth = 80
        }
        let screen1 = this.state.isRetina ? this.state.images[1] : this.state.images[0];
        let screen2 = this.state.isRetina ? this.state.images[3] : this.state.images[2];
        let screen3 = this.state.isRetina ? this.state.images[5] : this.state.images[4];
        return (
            <div id={"box-4"} className={"tsr-services"}>
                <FancyNavigation/>
                <SectionTitle title={text} width={titleWidth}/>
                <div className={"tsr-services-container"}>
                    <div className={"tsr-services-info"}>
                        <TsrServicesList/>
                    </div>
                    <div className={"tsr-services-screenshots"}>
                        <div className={"tsr-services-screenshots-screen scr1"}>
                            <Fade delay={700}>
                                <DisplayScreens screen={screen1}/>
                            </Fade>
                        </div>
                        <div className={"tsr-services-screenshots--screen scr2"}>
                            <Fade delay={1400}>
                                <DisplayScreens screen={screen2}/>
                            </Fade>
                        </div>
                        <div className={"tsr-services-screenshots--screen scr3"}>
                            <img className={"tsr-services_way"} src={process.env.PUBLIC_URL + 'way.svg'}/>
                            <Fade delay={2100}>
                                <DisplayScreens screen={screen3}/>
                            </Fade>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TSRServices;